<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-toolbar flat dense class="toolbar">
            <v-toolbar-title>Instructor Documents</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
        </v-toolbar>

        <v-data-table :headers="headers" :items="instructor_documents_list" class="elevation-1 mytable" sort-by="name"
            :search="search">
            <template v-slot:top>
                <v-toolbar flat dense color="white">
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="search" label="Search" style="padding: 10px" single-line
                        hide-details>
                    </v-text-field>
                    <span style="width: 20px"></span>

                    <v-dialog v-model="dialog" max-width="800px">
                        <template v-slot:activator="{ on }">
                            <v-btn class="button" v-on="on" small>Upload Documents</v-btn>
                        </template>

                        <v-card>
                            <v-card-title class="toolbar">
                                <span class="headline">Upload Document</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row dense justify="center" class="mt-3">
                                        <v-col cols="12" sm="8" md="8">

                                            <!-- Select -->
                                            <v-select v-model="document_type" label="Select Document Type"
                                                :items="document_type_list" item-text="name" item-value="id" dense
                                                outlined rounded prepend-icon="mdi-file" />

                                            <!-- File -->
                                            <v-file-input v-model="file" label="Select Document"
                                                prepend-icon="mdi-upload" show-size dense outlined />

                                        </v-col>

                                    </v-row>

                                    <v-row dense justify="center" class="mt-3">
                                        <v-btn text @click="uploadDocument()">
                                            <v-icon dark>mdi-cloud-upload</v-icon> Upload
                                        </v-btn>
                                    </v-row>
                                    <v-row dense justify="center" v-if="req_imagetype_doc">
                                        <b style="color: red">
                                            File Should Be In {{ req_imagetype_doc }} Format And Size
                                            Of Uploading Documents Should Be <= {{ req_imagetype_size }} MB </b>
                                    </v-row>

                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <!-- <v-btn class="button" @click="save">Save</v-btn> -->
                                <v-btn class="button" @click="close()">Cancel</v-btn>
                            </v-card-actions>

                        </v-card>
                    </v-dialog>

                </v-toolbar>
            </template>

            <template v-slot:[`item.document_path`]="{ item }">
                <span v-if="item.document_path">
                    <v-btn text color="primary" icon title="download">
                        <a :href="basepath + item.document_path" target="_blank" style="text-decoration: none">
                            <v-icon>mdi-eye</v-icon>
                        </a>
                    </v-btn>
                </span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.action="{ item }">
                <div>
                    <v-avatar style="" size="20" class="edit-avatar">
                        <v-icon color="red" class="delete-v-icon mr-2" @click="deleteAttachment(item)">delete</v-icon>
                    </v-avatar>
                </div>
            </template>
        </v-data-table>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <div class="text-center">
            <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please wait..
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        instid: Number,
    },
    data() {
        return {
            dialog: false,
            overlay: false,
            dialog_upload: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",

            headers: [
                {
                    text: "Sr. No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },

                {
                    text: "Document Name",
                    align: "left",
                    sortable: false,
                    value: "document_name",
                },
                {
                    text: "View File",
                    align: "left",
                    sortable: true,
                    value: "document_path",
                },

                { text: "Actions", value: "action", sortable: false },
            ],
            document_type_list: [],
            instructor_documents_list: [],
            req_imagetype_size: 10,
            req_imagetype_doc: ".png, .jpg, .jpeg, .pdf",

            document_type: "",
            file: null,
        };
    },
    watch: {
        instid() {
            this.getInstructorDocuments();
        },
    },
    mounted() {
        this.basepath = localStorage.getItem("awspath");
        this.getInstructorDocuments();
    },
    methods: {
        close() {
            this.dialog = false;
        },
        getInstructorDocuments() {
            const formData = {
                instid: this.instid,
            };

            axios
                .post("/EmployeeProfile/getInstructorDocuments", formData)
                .then((res) => {
                    const data = res.data;
                    if (data && data.flag === "YES") {
                        this.instructor_documents_list = data.instructor_documents_list;
                        this.document_type_list = data.document_type_list;
                    } else {
                        this.showSnackbar(
                            "#ff9800",
                            data.message || "Unable to fetch Document data."
                        );
                    }
                })
                .catch((error) => {
                    console.error("Error in getInstructorDocuments:", error);
                    this.showSnackbar(
                        "#b71c1c",
                        "Something went wrong while fetching documents!"
                    );
                })
                .finally(() => {
                });
        },
        deleteAttachment(item) {
            if (!confirm("Are you sure you want to delete this document?")) return;
            this.dialog_upload = true;
            const data = {
                instid: this.instid,
                doc_id: item.document_id,
            };

            axios
                .post("/EmployeeProfile/deleteInstructorDocument", data)
                .then((res) => {
                    this.dialog_upload = false;
                    if (res.data.status == "YES") {
                        this.instructor_documents_list = res.data.instructor_documents_list;
                        this.showSnackbar("#4caf50", "Document deleted successfully..."); // show snackbar on success
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar
                    }
                })
                .catch((error) => {
                    this.dialog_upload = false;
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.dialog_upload = false;
                });
        },
        uploadDocument() {

            if (this.document_type == null || this.document_type == '') {
                this.showSnackbar("#b71c1c", "Please select Document Type");
                return;
            }
            if (this.file == null) {
                this.showSnackbar("#b71c1c", "Please select file");
                return;
            }
            let formData = new FormData();
            formData.append("file", this.file);
            formData.append("instructor", this.instid);
            formData.append("documenttype", this.document_type);
            this.dialog_upload = true;

            axios
                .post("/EmployeeProfile/saveInstructorDocuments", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.showSnackbar("#4caf50", "Document uploaded successfully");
                        this.document_type = null;
                        this.instructor_documents_list = res.data.instructor_documents_list;
                        this.dialog = false;
                    } else if (res.data.status == "NOF") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                    } else if (res.data.status == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                        this.file = null;
                        this.dialog = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.dialog_upload = false;
                })
                .catch((error) => {
                    // alert("in else catch");
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.dialog_upload = false;
                })
                .finally(() => {
                    this.dialog_upload = false;
                    this.file = null;
                    this.dialog = false;
                });
        },


        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
};
</script>
<style scoped>
.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
    font-size: 80%;
}


.custom-toolbar {
    background: linear-gradient(to right, #a8edea, #e4d0ff);
    background: linear-gradient(to right, #a8edea, #e4d0ff);
}

.custom-header {
    background: linear-gradient(to right, #ffe0b2, #ffccbc);

    color: black !important;
    /* Optional: makes text readable */
    font-weight: bold;
}

.button-77 {
    color: #fff;
    cursor: pointer;
    font-weight: 800;
    vertical-align: middle;
    z-index: 0;
}

/* @media (min-width: 768px) {
  .button-77 {
    padding: 19px 32px;
  }
} */

.button-77:before,
.button-77:after {
    border-radius: 80px;
}

.button-77:before {
    background-color: rgba(249, 58, 19, 0.32);
    content: "";
}

.button-77:after {
    background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    content: "";
    display: block;
    left: 4px;
    overflow: hidden;
    position: absolute;
    right: 4px;
    top: 4px;
    transition: all 100ms ease-out;
    z-index: -1;
}

.button-77:hover:not(:disabled):after {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition-timing-function: ease-in;
}

.button-77:active:not(:disabled) {
    color: #ccc;
}

.button-77:active:not(:disabled):after {
    background-image: linear-gradient(0deg,
            rgba(0, 0, 0, 0.2),
            rgba(0, 0, 0, 0.2)),
        linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    left: 4px;
    right: 4px;
    top: 4px;
}

.button-77:disabled {
    cursor: default;
    opacity: 0.24;
}
</style>